import { GraphQLResult, generateClient } from "aws-amplify/api";
import { FormGroupForResolver } from "db/definitions";
import { getFormGroupById } from "db/queries/formGroupQueries";
// @ts-ignore
import { getFormGroupDocument } from "graphql/queries";

export async function _getFormGroupDocument(id: string, online: boolean): Promise<FormGroupForResolver | undefined> {
	interface QueryResponse {
		getFormGroup: FormGroupForResolver;
	}
	if (online) {
		const client = generateClient({ authMode: "userPool" });
		const formGroupResponse = (await client.graphql({
			query: getFormGroupDocument,
			authMode: "userPool",
			variables: {
				id,
			},
		})) as GraphQLResult<QueryResponse>;
		return formGroupResponse.data.getFormGroup;
	} else {
		const formGroup = await getFormGroupById(id);
		return formGroup;
	}
}
